import { Tools, windows } from "../tools/index"
const dutyFn = (to, from) => {
  setTimeout(() => {
    let clickBox = document.getElementById('clickBox');
    let childNodes = clickBox.childNodes;
    childNodes.forEach(item => {
      Tools.removeClass(item, "active");
    });
    childNodes.forEach(item => {
      if (item.dataset.path === to.name) {
        Tools.addClass(item, "active");
      }
    });

    if (to.name === "more" && from.name === "videos") {
      Tools.addClass(document.getElementById('headers_videos'), "active");
    }
    // if (to.name === "watch" && from.name === "more") {
    //   Tools.addClass(document.getElementById('headers_videos'), "active");
    // }
    // if (to.name === "watch" && from.name === "home") {
    //   Tools.addClass(document.getElementById('headers_videos'), "active");
    // }
    if (to.name === "watch") {
      Tools.addClass(document.getElementById('headers_videos'), "active");
    }
    if (to.name === "secondWatch") {
      Tools.addClass(document.getElementById('headers_videos'), "active");
    }
    if (to.name === 'home' || to.name === 'downloads') {
      Tools.removeClass(document.getElementById('Header-container'), "showBgRouter")
    } else {
      Tools.addClass(document.getElementById('Header-container'), "showBgRouter")
    }
    if (to.name === 'downloads') {
      Tools.addClass(document.getElementById("Headers"), "isDark");
    } else {
      Tools.removeClass(document.getElementById("Headers"), "isDark");
    }
    windows.backTop()
  }, 0)
}
export default dutyFn